import React from 'react';
import './Footer.css';
import logoImg from '../assets/logo.png'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Contact Info */}
          <div className="footer-section-m">
            <h3>معلومات التواصل</h3>
            
<div className='contact-item-phon'>
  

  <div className="contact-item">
    <i className="fas fa-phone"></i>
    <a href="tel:+966506552565">+966506552565</a>
  </div>
  <div className="contact-item">
    <i className="fas fa-phone"></i>
    <a href="tel:01011762864">01011762864</a>
  </div>
  <div className="contact-item">
    <i className="fas fa-phone"></i>
    <a href="tel:01110563323">01110563323</a>
  </div>

</div>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>شارع 68 ابو المحاسن الشاذلى العجوزة - الجيزة</span>
              </div>




              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <a href="mailto:support@alahram128.com">support@alahram128.com</a>
              </div>
            </div>
          </div>



          {/* Company Info */}
        
          <div className="footer-section">
            <div className="social-links">


              <a
                href="https://www.facebook.com/groups/467433135229688/?ref=share&mibextid=KtfwRi"
                target='_blank'
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a
                href="http://wa.me/+201012303458"
                target='_blank'
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
              <a
                href="https://www.tiktok.com/@alahram.company0"
                target='_blank'
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="https://www.linkedin.com/in/%D8%B4%D8%B1%D9%83%D8%A9-%D8%A7%D9%84%D8%A7%D9%87%D8%B1%D8%A7%D9%85-630676335/" aria-label="LinkedIn"
                target='_blank'>
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="https://www.instagram.com/cv.pyramids.egy/" aria-label="Instagram"
                target='_blank'>
                <i className="fab fa-instagram" ></i>
              </a>
            
            </div>
          
          </div>
          <div className="footer-logo">
                <img src={logoImg} alt="الأهرام ترخيص رقم 128" />
              </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;